/* eslint-disable */
import React, { useMemo, useState } from 'react';
import UIKitTable, { Cell } from '../../shared/UIKITComponents/Table';
import UIKitTablePagination from '../../shared/UIKITComponents/TablePagination';
import { DropDownStyleProps } from '../../shared/UIKITComponents/DropDownShell';

// Modelo simple
interface BigRow {
  id: number;
  col1: string;
  col2: string;
  col3: string;
  col4: string;
  col5: string;
}

const bigTableData: BigRow[] = Array.from({ length: 42 }).map((_, idx) => ({
  id: idx + 1,
  col1: `A${idx + 1}`,
  col2: `B${idx + 1}`,
  col3: `C${idx + 1}`,
  col4: `D${idx + 1}`,
  col5: `E${idx + 1}`,
}));

const bigTableCells: Cell<BigRow>[] = [
  { name: 'col1', column: 'Column 1', value: (x) => x.col1 ,width:100},
  { name: 'col2', column: 'Column 2', value: (x) => x.col2 },
  { name: 'col3', column: 'Column 3', value: (x) => x.col3 },
  { name: 'col4', column: 'Column 4', value: (x) => x.col4 },
  { name: 'col5', column: 'Column 5', value: (x) => x.col5 },
  { name: 'col1', column: 'Column 1', value: (x) => x.col1 ,width:100},
  { name: 'col2', column: 'Column 2', value: (x) => x.col2 },
  { name: 'col3', column: 'Column 3', value: (x) => x.col3 },
  { name: 'col4', column: 'Column 4', value: (x) => x.col4 },
  { name: 'col5', column: 'Column 5', value: (x) => x.col5 },
  { name: 'col1', column: 'Column 1', value: (x) => x.col1 ,width:100},
  { name: 'col2', column: 'Column 2', value: (x) => x.col2 },
  { name: 'col3', column: 'Column 3', value: (x) => x.col3 },
  { name: 'col4', column: 'Column 4', value: (x) => x.col4 },
  { name: 'col5', column: 'Column 5', value: (x) => x.col5 },
];

// Estilo del dropdown del paginador (40px de alto)
const dropDownSize: DropDownStyleProps = {
  height: 40,
  minHeight: 40,
  minWidth: 84,
  width: 84,
};

const SimpleTableWithFooterPagination: React.FC = () => {
  const [pageSize, setPageSize] = useState<number>(10);
  const [pageNumber, setPageNumber] = useState<number>(1);

  const total = bigTableData.length;

  const paginatedData = useMemo(() => {
    const start = (pageNumber - 1) * pageSize;
    return bigTableData.slice(start, start + pageSize);
  }, [pageNumber, pageSize]);

  return (
    <div style={{ padding: 24 }}>
      <h2>Tabla simple con paginación en el footer</h2>

      <UIKitTable<BigRow>
        data={paginatedData}
        cells={bigTableCells}
        keyFunc={(row) => row.id}
        headerContrast="low"
        tableHeight={430}
        footerContent={
          <UIKitTablePagination
            pageSize={pageSize}
            pageNumber={pageNumber}
            total={total}
            onChangeSize={(s) => {
              setPageSize(s);
              setPageNumber(1);
            }}
            onChangePage={(p) => setPageNumber(p)}
          />
        }
      />
    </div>
  );
};

export default SimpleTableWithFooterPagination;
